export const messagesSidebar = {
  pt: {
    message: {
      accessFileDimensions: "Para acessar as dimensões de arquivo, ",
      automation: "Automação",
      campaigns: "Campanhas",
      clickHere: "Clique aqui",
      comments: "Comentários",
      connections: "Conexões",
      billing: "Bilhetagem",
      coupons: "Cupons",
      dataOfTheDay: "Dados do dia",
      doubtsAboutStatistics: "Dúvidas sobre as estatísticas? ",
      establishments: "Estabelecimentos",
      external: "Externo",
      heatMap: "Mapa de calor",
      imports: "Importações",
      learnCreateCampaign: "Quer aprender a criar uma campanha? ",
      marketing: "Marketing",
      marketingNotActive:
        "Este serviço não está ativo para sua conta, para ativá-lo entre em contato com nossa equipe",
      marketingPlans: "Planos de marketing",
      monitoring: "Monitoramento",
      organizeLocalsAndAps: "Quer entender como organizar seus locais e APs? ",
      overview: "Visão geral",
      partners: "Parceiros",
      platformCustomization: "Personalização da Plataforma",
      platformDomain: "Domínio",
      platformScreens: "Telas da plataforma",
      registrations: "Cadastros",
      statistics: "Estatísticas",
      survey: "Pesquisa",
      systemEmails: "E-mails enviados pelo sistema",
      tag: "Tag",
      termsOfUse: "Termos de uso",
      users: "Usuários",
      twilioAccounts: "Contas Twilio",
      apsManagement: "Gerenciamento de APs",
      admins: "Administradores"
    },
  },
  es: {
    message: {
      accessFileDimensions: "Para acceder a las dimensiones del archivo",
      automation: "Automatización",
      campaigns: "Campañas",
      clickHere: "Haga clic aquí",
      comments: "Comentarios",
      connections: "Conexiones",
      billing: "Facturación",
      coupons: "Cupones",
      dataOfTheDay: "Datos del día",
      doubtsAboutStatistics: "¿Preguntas sobre estadísticas?",
      establishments: "Establecimientos",
      external: "Externo",
      heatMap: "Mapa de calor",
      imports: "Importaciones",
      learnCreateCampaign: "¿Quieres aprender a crear una campaña?",
      marketing: "Marketing",
      marketingNotActive:
        "Este servicio no está activo para su cuenta, para activarlo, contacte a nuestro equipo",
      marketingPlans: "Planes de marketing",
      monitoring: "Monitoreo",
      organizeLocalsAndAps:
        "¿Quieres entender cómo organizar tus lugares y AP?",
      overview: "Visión general",
      partners: "Socios",
      platformCustomization: "Personalización de la Plataforma",
      platformDomain: "Dominio",
      platformScreens: "Pantallas de la plataforma",
      registrations: "Registros",
      statistics: "Estadísticas",
      survey: "Búsquedas",
      systemEmails: "Correos electrónicos enviados por el sistema",
      tag: "Etiqueta",
      termsOfUse: "Terminos de uso",
      users: "Usuarios",
      twilioAccounts: "Cuentas de Twilio",
      apsManagement: "Gestión de APs",
      admins: "Administradores"
    },
  },
  en: {
    message: {
      accessFileDimensions: "To access file dimensions, ",
      automation: "Automation",
      campaigns: "Campaigns",
      clickHere: "Click here",
      comments: "Comments",
      connections: "Connections",
      billing: "Billing",
      coupons: "Coupons",
      dataOfTheDay: "Data of the day",
      doubtsAboutStatistics: "Doubts about the statistics? ",
      establishments: "Establishments",
      external: "External",
      heatMap: "Heat map",
      imports: "Imports",
      learnCreateCampaign: "Wanna learn how to create a campaign? ",
      marketing: "Marketing",
      marketingNotActive:
        "This service is not active for your account, to activate it, contact our team",
      marketingPlans: "Marketing plans",
      monitoring: "Monitoring",
      organizeLocalsAndAps:
        "Wanna understand how to organize your locals and APs? ",
      overview: "Overview",
      partners: "Partners",
      platformCustomization: "Platform Customization",
      platformDomain: "Domain",
      platformScreens: "Platform screens",
      registrations: "Registrations",
      statistics: "Statistics",
      survey: "Surveys",
      systemEmails: "Emails sent by the system",
      tag: "Tag",
      termsOfUse: "Terms of use",
      users: "Users",
      twilioAccounts: "Twilio Accounts",
      apsManagement: "AP Management",
      admins: "Administrators"
    },
  },
};
